export const API_URL = window["apiUrl"];
export const PATH = window["path"];
export const LEGAL_PATROCINADOR_CALIENTE = window["legal_patrocinador_caliente"];
export const LEGAL_PATROCINADOR_CODERE = window["legal_patrocinador_codere"];
export const API_LOCAL = window["apiLocal"];
export const API_PATH_PARTIDOS = window["apiUrlPartidos"];